// Calculos puros del inventario. Sin React ni red.
export const itemTotal = (movements = []) =>
  movements.reduce((sum, m) => sum + (Number(m.cantidad) || 0), 0)

export const itemPrestados = (loans = []) =>
  loans
    .filter((l) => !l.fecha_devolucion)
    .reduce((sum, l) => sum + (Number(l.cantidad) || 0), 0)

export const buildOverview = (items = [], movements = [], loans = []) =>
  items.map((item) => {
    const ms = movements.filter((m) => m.item_id === item.id)
    const ls = loans.filter((l) => l.item_id === item.id)
    const total = itemTotal(ms)
    const prestados = itemPrestados(ls)
    return { ...item, total, prestados, disponibles: total - prestados }
  })

export const lineDiferencia = (line = {}) => {
  if (line.cantidad_real === null || line.cantidad_real === undefined) return 0
  return (Number(line.cantidad_real) || 0) - (Number(line.cantidad_esperada) || 0)
}

export const lineasAjustables = (lines = []) =>
  lines
    .filter((l) => l.ajustar && l.cantidad_real !== null && l.cantidad_real !== undefined)
    .map((l) => ({ ...l, diferencia: lineDiferencia(l) }))
    .filter((l) => l.diferencia !== 0)

export const buildReporte = (items = [], movements = [], { desde = null, hasta = null } = {}) =>
  items.map((item) => {
    const ms = movements.filter((m) => m.item_id === item.id)
    const antes = (m) => (desde ? m.fecha < desde : false)
    const hasta_inc = (m) => (hasta ? m.fecha <= hasta : true)
    const enRango = (m) => (desde ? m.fecha >= desde : true) && hasta_inc(m)
    const sum = (arr) => arr.reduce((s, m) => s + (Number(m.cantidad) || 0), 0)

    const inicial = sum(ms.filter(antes))
    const rango = ms.filter(enRango)
    const agregados = sum(rango.filter((m) => m.tipo === 'alta'))
    const perdidos = -sum(rango.filter((m) => m.tipo === 'perdida'))
    const desechados = -sum(rango.filter((m) => m.tipo === 'desecho'))
    const ajustes = sum(rango.filter((m) => m.tipo === 'ajuste'))
    const final = sum(ms.filter(hasta_inc))

    return { ...item, inicial, agregados, perdidos, desechados, ajustes, final }
  })
